import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { createStyles, Theme } from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import { useSelector } from "react-redux";
import { State } from "../../store";
import { useHistory } from "react-router";
import { FINALIZE_PAGE } from "../../Routing/routes";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    listItem: {
      marginTop: 40,
      marginRight: "5%",
      width: "90%",
      textTransform: "uppercase",
      borderRadius: 10,
      textAlign: "center",
      color: "#fff",
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        color: "#3db0e2 !important",
        backgroundColor: "#fff"
      }
    },
    itemText: {
      fontSize: 12,
      fontWeight: "bold",
      "&:hover": {
        color: "#3db0e2 !important"
      }
    },
    button: (props: any) => ({
      position: props.position,
      bottom: 20,
      width: 120,
      height: 50,
      backgroundColor: "#fff",
      color: "#000",
      "&:hover": {
        color: "#fff !important",
        backgroundColor: theme.palette.primary.main
      },
      cursor: "pointer",
      border: `2px solid ${theme.palette.primary.main}`,
      borderRadius: "14px"
    }),
    buttonDesktop: {
      right: "2vw"
    },
    buttonMobile: {
      right: "2vw"
    }
  })
);

const FinalizeBasketBtn: React.FC = () => {
  const position = "fixed";
  const classes = useStyles({ position });
  const basket = useSelector((state: State) => state.basket.basket);
  const getBasketQnt = () => basket.reduce((acc: number, item) => acc + item.quantity, 0);
  const history = useHistory();

  const handleClick = () => {
    history.push(FINALIZE_PAGE);
  };

  return (
    <>
      {getBasketQnt() > 0 && (
        <>
          <Hidden mdDown>
            <button
              className={`${classes.button} ${position === "fixed" ? classes.buttonDesktop : classes.buttonMobile}`}
              onClick={() => handleClick()}
            >
              <span>Finalizacja</span>
              <span style={{ fontWeight: 700, fontSize: 16 }}>{` (${getBasketQnt()})`}</span>
            </button>
          </Hidden>
          <Hidden lgUp>
            <button className={`${classes.button} ${classes.buttonMobile}`} onClick={() => handleClick()}>
              <span>Finalizacja</span>
              <span style={{ fontWeight: 700, fontSize: 16 }}>{` (${getBasketQnt()})`}</span>
            </button>
          </Hidden>
        </>
      )}
    </>
  );
};

export default FinalizeBasketBtn;
